import SocialMediaIcons from "./SocialMediaIcons";

export default function Card() {
  return (
    <div className="absolute hidden md:block  font-open left-0 w-[440px] shadow-2xl bg-[#cd2122] z-10  pt-[30px] pb-[25px] px-5 mt-[1px] text-xs leading-5 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100 group-hover:top-full top-[120%] group-hover:pointer-events-auto pointer-events-none">
      <div className="flex">
        <div className="w-[44%] px-[15px]">
          <div className="flex flex-col mt-[15px] items-center logo-container">
            <img
              src="../../../assets/mean3-black-logo.png"
              className="w-full h-[150px]"
              alt="Mean3 Black Logo"
            />
            <p className="text-center mt-[20px] capitalize">Mean3 Software Solution provider</p>
          </div>
        </div>
        <div className="w-[56%] px-[15px]">
          <p className="mb-5 !text-[14px]">
            <strong><a href="tel:+1 (832) 278-2928">+1 (832) 278-2928</a></strong> <br />
            Email: <a href="mailto:info@mean3.com" className="hover:text-[hsla(0,0%,100%,.7)]">info@mean3.com</a>
          </p>
          <a href="https://g.co/kgs/PT58Zgm">
          <p className="mb-5 !text-[14px]">
            Mean3 Software Solutions <br />
            447 Broadway, 2nd Floor Suite #670, New York, New York 10013, United States
          </p></a>
          <SocialMediaIcons />
        </div>
      </div>
    </div>
  );
}
